/* eslint-disable no-console */

import { register } from "register-service-worker";
const VAPID_PUBLIC_KEY =
  "BCjeMacqb2H10eME0q8M06QjH1d3u_DwwMZ0Wq6rCdoKAA7D6Wfp05FwaR9Jj6MsMaBLKXNwV62e0uliDT8kmmc=";

register(`/mobile/service-worker.js`, {
  ready() {
    console.log(
      "App is being served from cache by a service worker.\n" +
        "For more details, visit https://goo.gl/AFskqB"
    );
  },
  registered(registration) {
    console.log("Service worker has been registered.");

    Notification.requestPermission(function () {
      if (Notification.permission === "granted") {
        // Get the push notification subscription object
        registration.pushManager
          .getSubscription()
          .then(function (subscription) {
            // If this is the user's first visit we need to set up
            // a subscription to push notifications
            if (!subscription) {
              subscribe(registration, subscription);
              return;
            }

            // Update the server state with the new subscription
            subscribeMeldediesnt(subscription);
          });
      } else if (Notification.permission === "denied") {
        // user denied.
      } else {
        // Notification.permission === 'default'
        // user didn’t make a decision.
        // You can’t send notifications until they grant permission.
      }
    });
  },
  cached() {
    console.log("Content has been cached for offline use.");
  },
  updatefound() {
    console.log("New content is downloading.");
  },
  updated() {
    console.log("New content is available; please refresh.");
  },
  offline() {
    console.log(
      "No internet connection found. App is running in offline mode."
    );
  },
  error(error) {
    console.error("Error during service worker registration:", error);
  },
});

function subscribeMeldediesnt(pushSubscription: PushSubscription) {
  const key = pushSubscription.getKey ? pushSubscription.getKey("p256dh") : "";
  const auth = pushSubscription.getKey ? pushSubscription.getKey("auth") : "";
  console.log(pushSubscription.endpoint);
  console.log(key);
  console.log(auth);

  // The push subscription details needed by the application
  // server are now available, and can be sent to it using,
  // for example, an XMLHttpRequest.
}

function subscribe(
  registration: ServiceWorkerRegistration,
  pushSubscription: null
) {
  const subscribeOptions = {
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  };

  registration.pushManager.subscribe(subscribeOptions).then(
    function (pushSubscription) {
      subscribeMeldediesnt(pushSubscription);
    },
    function (error) {
      // During development it often helps to log errors to the
      // console. In a production environment it might make sense to
      // also report information about errors back to the
      // application server.
      console.log(error);
    }
  );
}

function urlBase64ToUint8Array(base64String: string | any[]) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
